module.exports = __webpack_public_path__ + "static/media/JE.55d15529.svg";